import { PropsWithChildren, ReactNode } from 'react';
import { FallbackProps } from 'react-error-boundary';

export type ChildrenProps = PropsWithChildren<Record<string, unknown>>;

export interface ErrorPageProps extends FallbackProps {
  error: Error | [Error];
}

export enum ErrorTags {
  local = 'local-error',
  global = 'global-error',
  xstate = 'xstate-error',
}

/**
 * Which kind of error the app's state machine is currently reporting.
 *
 * Resolved by each app from its OWN XState hook and handed in, because the
 * machines differ; everything the boundary does with the answer is identical.
 */
export interface ErrorFlags {
  isLocalError: boolean;
  isGlobalError: boolean;
  isXstateError: boolean;
}

/** Text the boundary renders. Supplied already translated by the app. */
export interface ErrorPageLabels {
  /**
   * Optional line under the error message.
   *
   * A STRING, not a node: `Result` takes it as a Lit attribute, so a React node
   * would be stringified into `[object Object]` on screen.
   */
  body?: string;
  /** Button labels, which are children and may therefore be nodes. */
  reload: ReactNode;
  home: ReactNode;
}
